const $doc = $(document)
const $win = $(window)
const MOBILE_WIDTH = 768

$doc.on('click', '.js-btn-ajax', function (e) {
  const $this = $(this)
  let flag = false

  if ($this.attr('data-js-btn-ajax-mobile') !== undefined) {
    if ($win.width() < MOBILE_WIDTH) {
      flag = true
    }
  } else {
    flag = true
  }

  if (flag) {
    e.preventDefault()
    const className = $this.data('js-btn-ajax-class')
    const $targetClass = $($this.data('js-btn-ajax-class-target'))
    const $target = $($this.data('js-btn-ajax-target'))
    const url = $this.attr('href')
    const ajaxTargetClass = $this.data('js-btn-ajax-target-class')

    $.ajax({
      url: url,
    })
      .done(function(data) {
        const $data = $(data)
        const $dataTarget = $data.find(`${ajaxTargetClass}`)

        if ($dataTarget.length) {
          $target
            .empty()
            .append($dataTarget.html())
          $targetClass.addClass(className)

          if ($this.hasClass('js-btn-ajax-get-body-class') && data.indexOf('<body class="') !== -1) {
            const bodyClassName = data.split('<body class="')[1].split('"')[0]

            $targetClass.attr('data-ajax-class', bodyClassName)
          }

          if ($targetClass.hasClass('popup')) {
            $targetClass.scrollTop(0)
          }
        }
      });
  }
})
